module.exports = __webpack_public_path__ + "img/exam_jan_2025_6ejlq5d9.4d8087b1.jpg";